module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/th/2-e2c879f6850d1f073b957c95cf4d1105.jpg";